(function () {
  console.log("shipping-calculator.js carregado - versão com ver mais e ver menos");

  const svgOk = `
    <svg xmlns="http://www.w3.org/2000/svg" id="Camada_1" version="1.1" viewBox="0 0 1 1" width="17" height="17">
      <defs>
        <style>
          .st0 {
            fill: none;
            stroke: #1e1f1d;
            stroke-miterlimit: 10;
            stroke-width: .07px;
          }
        </style>
      </defs>
      <path class="st0" d="M.91.92H.16v-.22h.39L.09.22.22.08l.47.48V.15h.22v.77Z"/>
    </svg>
  `;

  const spinnerLoading = `<span class="loader"></span>`;

  const MESSAGES = {
    noVariant: "Escolha um produto com estoque para calcular o frete.",
    invalidCep: "Formato de CEP inválido. Use o formato 12345-678.",
    noRates: "Nenhuma taxa de frete encontrada.",
    cepError: "Erro ao buscar o CEP. Tente novamente.",
    cartAddError: "Erro ao adicionar o produto ao carrinho.",
    cartRemoveError: "Erro ao atualizar o carrinho.",
    shippingCalcError: "Erro ao calcular o frete. Tente novamente.",
    asyncError: "Erro ao buscar as taxas de frete.",
    genericError: "Ocorreu um erro inesperado. Tente novamente mais tarde.",
  };

  const getButton = () => document.querySelector(".get-rates");
  const getZipInput = () => document.querySelector("#address_zip");
  const getResponseWrapper = () => document.querySelector("#wrapper-response");

  const escapeHTML = (value) => {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  };

  const UI = {
    enableButton: () => {
      const button = getButton();
      if (!button) return;

      button.disabled = false;
      button.innerHTML = svgOk;
    },

    disableButton: () => {
      const button = getButton();
      if (!button) return;

      button.disabled = true;
      button.innerHTML = spinnerLoading;
    },

    clearResponse: () => {
      const wrapper = getResponseWrapper();
      if (!wrapper) return;

      wrapper.innerHTML = "";
      wrapper.style.display = "none";
    },

    showMessage: (message, type = "error") => {
      const wrapper = getResponseWrapper();
      if (!wrapper) return;

      const color = type === "success" ? "green" : "red";

      wrapper.innerHTML = `
        <div class="message" style="color: ${color}; margin-top: 10px; font-size: 14px;">
          ${escapeHTML(message)}
        </div>
      `;

      wrapper.style.display = "block";
    },
  };

  const log = (message, type = "log") => {
    if (window.debugMode && console[type]) {
      console[type](message);
    }
  };

  const requestJson = async (url, options = {}) => {
    const response = await fetch(url, {
      credentials: "same-origin",
      ...options,
      headers: {
        Accept: "application/json",
        ...(options.headers || {}),
      },
    });

    if (!response.ok) {
      throw new Error(`Erro HTTP ${response.status}`);
    }

    return response.json();
  };

  const postForm = async (url, data) => {
    const body = new URLSearchParams();

    Object.keys(data).forEach((key) => {
      body.append(key, data[key]);
    });

    const response = await fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: body.toString(),
    });

    if (!response.ok) {
      throw new Error(`Erro HTTP ${response.status}`);
    }

    return response.json();
  };

  const postNestedForm = async (url, data) => {
    const body = new URLSearchParams();

    Object.keys(data).forEach((parentKey) => {
      const value = data[parentKey];

      if (typeof value === "object" && value !== null) {
        Object.keys(value).forEach((childKey) => {
          body.append(`${parentKey}[${childKey}]`, value[childKey]);
        });
      } else {
        body.append(parentKey, value);
      }
    });

    const response = await fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: body.toString(),
    });

    if (!response.ok) {
      throw new Error(`Erro HTTP ${response.status}`);
    }

    return response;
  };

  const getFirstAvailableVariantId = () => {
    const variants = document.querySelectorAll("#product-variants .variant");

    for (const variant of variants) {
      const available = String(variant.getAttribute("data-available")) === "true";
      const quantity = Number(variant.getAttribute("data-quantity")) || 0;
      const variantId = variant.getAttribute("data-id");

      if (available && quantity > 0 && variantId) {
        return variantId;
      }

      /*
        Se sua loja vende sem controlar estoque, troque a condição acima por:

        if (available && variantId) {
          return variantId;
        }
      */
    }

    return null;
  };

  const getCartContents = async () => {
    return requestJson("/cart.js");
  };

  const addFakeProductToCart = async (variantId) => {
    return postForm("/cart/add.js", {
      id: variantId,
      quantity: 1,
    });
  };

  const removeFakeProductFromCart = async (variantId) => {
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          updates: {
            [variantId]: 0,
          },
        }),
      });

      if (!response.ok) {
        throw new Error(`Erro HTTP ${response.status}`);
      }

      log("Produto fake removido com sucesso.", "info");
    } catch (error) {
      console.error(error);
      UI.showMessage(MESSAGES.cartRemoveError);
    }
  };

  const applyCepMask = () => {
    document.addEventListener("input", function (event) {
      if (!event.target || event.target.id !== "address_zip") return;

      let value = event.target.value.replace(/\D/g, "").slice(0, 8);

      if (value.length > 5) {
        value = value.replace(/^(\d{5})(\d{1,3})$/, "$1-$2");
      }

      event.target.value = value;
    });
  };

  const fetchProvinceFromZip = async (zip) => {
    const cleanZip = zip.replace("-", "");

    try {
      const data = await requestJson(`https://viacep.com.br/ws/${cleanZip}/json/`, {
        credentials: "omit",
      });

      if (data.erro) {
        UI.showMessage(MESSAGES.cepError);
        return null;
      }

      return data.uf;
    } catch (error) {
      console.error(error);
      UI.showMessage(MESSAGES.cepError);
      return null;
    }
  };

  const normalizePickupName = (name) => {
    const cleanName = String(name || "").trim();

    const pickupText = "Retirada em loja";
    const lowerName = cleanName.toLowerCase();
    const pickupIndex = lowerName.indexOf(pickupText.toLowerCase());

    if (pickupIndex === -1) {
      return {
        title: cleanName,
        subtitle: "",
      };
    }

    let subtitle = cleanName.slice(pickupIndex + pickupText.length).trim();

    subtitle = subtitle
      .replace(/^[-–—|:,.\s]+/, "")
      .replace(/\s*\|\s*/g, " ")
      .replace(/\s{2,}/g, " ")
      .trim();

    return {
      title: "Retirada em loja",
      subtitle,
    };
  };

  const formatDeliveryDays = (originalRateName, deliveryDays) => {
    const cleanName = String(originalRateName || "").trim();

    if (cleanName === "Local Delivery") {
      return "1 dia útil";
    }

    if (!deliveryDays || deliveryDays === "N/A") {
      return "N/A";
    }

    const daysNumber = Number(deliveryDays);

    if (Number.isFinite(daysNumber)) {
      return daysNumber === 1 ? "1 dia útil" : `${daysNumber} dias úteis`;
    }

    return deliveryDays;
  };

  const formatPrice = (priceValue) => {
    const numericPrice = Number(priceValue);

    if (!Number.isFinite(numericPrice)) {
      return "";
    }

    if (numericPrice === 0) {
      return "GRÁTIS";
    }

    return `R$ ${numericPrice.toFixed(2).replace(".", ",")}`;
  };

  const displayShippingRates = (rates) => {
    const wrapper = getResponseWrapper();
    if (!wrapper) return;

    let responseHTML = "<ul class='shipping-rates-list'>";

    if (rates && rates.length > 0) {
      rates.forEach((rate, index) => {
        const originalName = rate.name || "";
        let displayName = originalName;
        const deliveryDays = rate.delivery_days?.[0] || "N/A";

        if (displayName === "Local Delivery") {
          displayName = "ENTREGA LOCAL";
        }

        const shippingInfo = normalizePickupName(displayName);
        const formattedDeliveryDays = formatDeliveryDays(originalName, deliveryDays);
        const price = formatPrice(rate.price);

        const hiddenClass = index >= 2 ? "shipping-hidden-option" : "";

        responseHTML += `
          <li class="shipping-rate-item ${hiddenClass}">
            <div class="shipping-info">
              <div class="shipping-name">${escapeHTML(shippingInfo.title)}</div>
              ${
                shippingInfo.subtitle
                  ? `<div class="shipping-address">${escapeHTML(shippingInfo.subtitle)}</div>`
                  : ""
              }
            </div>

            <div class="shipping-right">
              <div class="shipping-price">${escapeHTML(price)}</div>
              <div class="shipping-days">${escapeHTML(formattedDeliveryDays)}</div>
            </div>
          </li>
        `;
      });

      if (rates.length > 2) {
        responseHTML += `
          <li class="shipping-toggle-item">
            <button type="button" class="shipping-toggle-options" data-expanded="false">
              VER OUTRAS OPÇÕES DE FRETE
            </button>
          </li>
        `;
      }
    } else {
      responseHTML += `<li>${escapeHTML(MESSAGES.noRates)}</li>`;
    }

    responseHTML += "</ul>";

    wrapper.innerHTML = responseHTML;
    wrapper.style.display = "block";

    const toggleButton = wrapper.querySelector(".shipping-toggle-options");

    if (toggleButton) {
      toggleButton.addEventListener("click", function () {
        const isExpanded = toggleButton.getAttribute("data-expanded") === "true";
        const hiddenOptions = wrapper.querySelectorAll(".shipping-rate-item:nth-child(n+3)");

        if (isExpanded) {
          hiddenOptions.forEach((option) => {
            option.classList.add("shipping-hidden-option");
          });

          toggleButton.setAttribute("data-expanded", "false");
          toggleButton.textContent = "VER OUTRAS OPÇÕES DE FRETE";
        } else {
          hiddenOptions.forEach((option) => {
            option.classList.remove("shipping-hidden-option");
          });

          toggleButton.setAttribute("data-expanded", "true");
          toggleButton.textContent = "VER MENOS OPÇÕES DE FRETE";
        }
      });
    }

    UI.enableButton();
  };

  const pollForShippingRates = async (fakeVariantId, retries = 0, maxRetries = 8) => {
    if (retries >= maxRetries) {
      UI.showMessage(MESSAGES.asyncError);
      UI.enableButton();

      if (fakeVariantId) {
        await removeFakeProductFromCart(fakeVariantId);
      }

      return;
    }

    setTimeout(async () => {
      try {
        const response = await requestJson("/cart/async_shipping_rates");

        if (response && response.shipping_rates) {
          displayShippingRates(response.shipping_rates);

          if (fakeVariantId) {
            await removeFakeProductFromCart(fakeVariantId);
          }
        } else {
          pollForShippingRates(fakeVariantId, retries + 1, maxRetries);
        }
      } catch (error) {
        console.error(error);
        UI.showMessage(MESSAGES.asyncError);
        UI.enableButton();

        if (fakeVariantId) {
          await removeFakeProductFromCart(fakeVariantId);
        }
      }
    }, 700);
  };

  const calculateShipping = async (address, fakeVariantId = null) => {
    try {
      await postNestedForm("/cart/prepare_shipping_rates", {
        shipping_address: address,
      });

      pollForShippingRates(fakeVariantId);
    } catch (error) {
      console.error(error);
      UI.showMessage(MESSAGES.shippingCalcError);
      UI.enableButton();

      if (fakeVariantId) {
        await removeFakeProductFromCart(fakeVariantId);
      }
    }
  };

  const handleCalculateClick = async (event) => {
    event.preventDefault();

    const input = getZipInput();

    if (!input) {
      UI.showMessage(MESSAGES.genericError);
      return;
    }

    const zip = input.value.trim();

    UI.clearResponse();

    if (!/^\d{5}-\d{3}$/.test(zip)) {
      UI.showMessage(MESSAGES.invalidCep);
      return;
    }

    UI.disableButton();

    const province = await fetchProvinceFromZip(zip);

    if (!province) {
      UI.enableButton();
      return;
    }

    try {
      const cart = await getCartContents();

      if (cart.items && cart.items.length > 0) {
        calculateShipping({
          zip,
          country: "BR",
          province,
        });
      } else {
        const variantId = getFirstAvailableVariantId();

        if (!variantId) {
          UI.showMessage(MESSAGES.noVariant);
          UI.enableButton();
          return;
        }

        try {
          await addFakeProductToCart(variantId);

          calculateShipping(
            {
              zip,
              country: "BR",
              province,
            },
            variantId
          );
        } catch (error) {
          console.error(error);
          UI.showMessage(MESSAGES.cartAddError);
          UI.enableButton();
        }
      }
    } catch (error) {
      console.error(error);
      UI.showMessage(MESSAGES.genericError);
      UI.enableButton();
    }
  };

  const initShippingCalculator = () => {
    try {
      const button = getButton();
      const input = getZipInput();

      if (!button || !input) {
        console.warn("Calculadora de frete não encontrada na página.");
        return;
      }

      applyCepMask();

      button.removeEventListener("click", handleCalculateClick);
      button.addEventListener("click", handleCalculateClick);

      log("Calculadora de frete iniciada sem jQuery.", "info");
    } catch (error) {
      console.error(error);
      UI.showMessage(MESSAGES.genericError);
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initShippingCalculator);
  } else {
    initShippingCalculator();
  }
})();